import * as Factory from 'factory.ts'
import faker from 'faker'

import { type AdditionalBillCostType } from '@webapp/models/AdditionalBillCost'
import { AccountMock } from './account.factory'

export const AdditionalBillCostTypeMock =
  Factory.Sync.makeFactory<AdditionalBillCostType>({
    id: Factory.each(() => faker.random.number()),
    name: Factory.each(() => faker.finance.transactionType()),
    active: Factory.each(() => true),
    budget: AccountMock.build(),
  })
